import React, { useEffect, useState } from 'react'
type Me = { discordId:string; tag?:string|null; isAdmin:boolean } | null

export default function AdminTopRight() {
  const [me,setMe] = useState<Me>(null)
  const [checked,setChecked] = useState(false)

  useEffect(()=>{ (async()=>{
    try{ const r = await fetch('/api/me'); const d = await r.json(); setMe(d.me||null) }catch{}
    setChecked(true)
  })() }, [])

  if (!checked) return null
  if (!me || !me.isAdmin) {
    return (
      <div className="topRight">
        <a className="btn" href="/auth/login">Zaloguj przez Discord</a>
        <style>{css}</style>
      </div>
    )
  }
  return (
    <div className="topRight">
      <a className="btn ghost" href="/admin">↩ Powrót do panelu</a>
      <style>{css}</style>
    </div>
  )
}

const css = `
.topRight{position:fixed;top:16px;right:16px;z-index:1100}
.btn{display:inline-block;padding:10px 14px;border-radius:10px;background:#5865F2;color:#fff;text-decoration:none;font-weight:700}
.btn.ghost{background:#1b2440;border:1px solid #2a3046}
`
